import { AfterViewInit, Component } from '@angular/core'
import { openCaseManagementDialog } from '../../shared/utils/case-management-dialog-utils'

@Component({
    selector: 'app-no-case',
    templateUrl: './no-case.component.html',
    styleUrls: ['./no-case.component.scss'],
})
export class NoCaseComponent implements AfterViewInit {
    ngAfterViewInit(): void {
        setTimeout(() => openCaseManagementDialog())
    }
}
